<!--
 * @Author: 曹捷
 * @Date: 2019-08-19 15:24:34
 * @LastEditors: 曹捷
 * @LastEditTime: 2021-11-08 17:15:45
 * @Description: 重置密码
 -->
<template>
  <a-modal class="obit-modal-default" :maskClosable="false" title="重置密码" v-model:visible="open" :confirm-loading="confirmLoading" @cancel="closeDialog" @ok="saveInfo" cancelText="取消" okText="确认"
    width="580px">
    <a-form :inline="true" :model="formData" :rules="rules" ref="formRef" :label-col="{span: 5}" :wrapper-col="{span:18}">
      <a-form-item label="新密码" name="password">
        <a-input :maxlength="20" placeholder="请输入新密码" type="password" show-word-limit v-model:value="formData.password">
        </a-input>
      </a-form-item>
      <a-form-item label="再次确认密码" name="passwordAgain">
        <a-input :maxlength="20" placeholder="再次输入密码" type="password" show-word-limit v-model:value="formData.passwordAgain">
        </a-input>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { inject, reactive, toRefs } from 'vue'
import { util } from 'obit-wui'
export default {
  props: {
    open: {
      type: Boolean
    },
    userId: {
      type: String,
    },
  },
  setup (props, context) {
    let password = (rule, value, callback) => {
      if (!value) {
        callback(new Error('设置登录密码'));
      } else {
        if (value.length < 6) {
          callback(new Error('密码长度不能低于6位'));
        } else {
          callback();
        }
      }
    }
    let passwordAgain = (rule, value, callback) => {
      if (!value) {
        callback(new Error('输入密码'));
      } else {
        if (value !== _data.formData.password) {
          callback(new Error('两次输入密码不一致'));
        } else {
          if (value.length < 6) {
            callback(new Error('密码长度不能低于6位'));
          } else {
            callback();
          }
        }
      }
    }
    let http = inject('http')
    let _data = reactive({
      formData: {},
      formRef: null,
      confirmLoading: false,
      rules: {
        password: [
          { required: true, validator: password, trigger: 'blur' },
        ],
        passwordAgain: [
          { required: true, validator: passwordAgain, trigger: 'blur' },
        ],
      }
    })
    let _methods = {
      saveInfo () {
        _data.formRef.validate().then(() => {
          _data.confirmLoading = true
          let data = {
            userId: props.userId,
            password: _data.formData.password
          }
          http.sysPost('system/user/resetPwd', data).then((res) => {
            context.emit('reload')
            _methods.closeDialog()
          }).catch(() => {
            _data.confirmLoading = false
          })
        })
      },
      closeDialog () {
        util.util.cleanObj(_data.formData)
        context.emit('update:open', false)
      },
    }
    return {
      ...toRefs(_data),
      ..._methods
    }
  },
}
</script>
<style lang="less">
</style>